var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("cost-bottom flex " + _vm.width)},[_c('div',{staticClass:"cost-bt-bg"}),_c('div',{staticClass:"cost-bt-body items-center w-full justify-center"},[_c('span',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }